import { OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DentallyWizardService } from '../../wizards/dentally/dentally-wizard.service';
import { IntegrationCustomerStatus } from '../../wizards/dentally/IntegrationCustomerStatus';
import * as moment from 'moment';
import { FlexAlignStyleBuilder } from '@angular/flex-layout';

@Component({
  selector: 'app-launch-button-dialog',
  templateUrl: './launch-button-dialog.component.html',
  styleUrls: ['./launch-button-dialog.component.scss']
})
export class LaunchButtonDialogComponent implements OnInit, OnDestroy {
  
  isLoading = false;
  showError = false;
  intevalTimer: any;
  errorText = "";

  constructor(private dialogRef: MatDialogRef<LaunchButtonDialogComponent>, 
              private dentallyService: DentallyWizardService) { }

  ngOnInit() {
  }

  onCancelClick($event: Event) {
    $event.preventDefault();
    this.dialogRef.close(null);
  }

  onStartClick(){
    this.isLoading=true;
    this.showError=false;
    this.errorText="";
    this.dentallyService.launchIntegration()
    .subscribe(()=>{
      this.checkIntegrationStatus();
    }, (err)=>{
      this.showError=true;
      this.isLoading=false;
      this.errorText = "Something went wrong. We were not able to start pulling data from Dentally. Please contact us."
     });   
    
  }

  checkIntegrationStatus(){
    const startCheckingTime = moment();
    const self = this;
    self.intevalTimer = setInterval(() => {
      self.getIntegrationStatus(startCheckingTime,self);      
    },3000);
    
  }

  private getIntegrationStatus(startCheckingTime: moment.Moment, self:LaunchButtonDialogComponent) {
    self.dentallyService.getIntegrationStatus()
      .subscribe((r: IntegrationCustomerStatus) => {
        if (r.status === "Finalized") {
          clearInterval(self.intevalTimer);
          self.dialogRef.close();
        }
        else if (r.status === "Error") {
          self.isLoading = false;
          self.showError = true;
          clearInterval(self.intevalTimer);
        }
        else {
          const now = moment();
          const timeDiff = now.diff(startCheckingTime, "minutes");
          if ( timeDiff> 5) {
            self.showError = true;
            self.errorText = "Something went wrong. We were not able to finalize connection with Dentally. Please contact us."
            clearInterval(self.intevalTimer);
          }
        }
      }, (err) => {
        self.showError = true;
        self.errorText = "Something went wrong. We were not able to get status of integration. Please contact us."
        self.isLoading = false;       
        clearInterval(self.intevalTimer);
      });
  }

  ngOnDestroy(): void {
    if (this.intevalTimer) {
      clearInterval(this.intevalTimer);
    }
  }

}
